<template>
  <div :class="$groupsStyle.enlargedContainer">
    <div :class="$groupsStyle.titleContainer">
      <div :class="$groupsStyle.titleText">{{ $t("all-groups-game-texts-votes") }}</div>
      <div :class="$groupsStyle.actionsContainer">
        <!-- <div title="View text details" :class="$style.infoContainer" @click="openInfoModal">
          <img :class="$style.infoIcon" :src="infoIcon" alt="info" />
        </div> -->
        <div title="Close this box" :class="$groupsStyle.closeContainer" @click="props.closeAllGroupsGameTextsVotes">
          <img :class="$groupsStyle.closeIcon" :src="closeIcon" alt="close" />
        </div>
      </div>
    </div>
    <div :class="$groupsStyle.bodyContainer">
      <div v-for="(group, index) in props.groups" :key="index" :class="$style.groupGameTextsVotesContainer">
        <GameTextsVoteBox
          :players="group.players"
          :textVotes="group.textVotes"
          :isHost="isHost"
          :user="user"
          :isGroupComponent="true"
          :title="getGroupDisplayName(group, index, t)"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import styles from "@/css/AllGroupsGameTextsVotesBox.module.css";
import groupsStyles from "@/css/groupsUtil.module.css";
import CloseIcon from "@/assets/icons/close-red.svg";
import GameTextsVoteBox from "./GameTextsVoteBox.vue";
import { getGroupDisplayName } from "@/utils/functions";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
const $style = styles;
const $groupsStyle = groupsStyles;
const closeIcon = CloseIcon;

// eslint-disable-next-line
const props = defineProps({
  closeAllGroupsGameTextsVotes: {
    type: Function,
    required: true,
  },
  groups: {
    type: Array,
    required: true,
  },
  isHost: {
    type: Boolean,
    required: true,
  },
  user: {
    type: Object,
    required: true,
  },
});
</script>

<style scope></style>
